module.exports = __webpack_public_path__ + "static/media/halfround.f7d12dee.jpg";